import { graphql } from 'relay-runtime';

export const upsertStudentTargetGroupsForStudent = graphql`
  mutation DiagnosticUpsertStudentTargetGroupsForStudentMutation($input: UpsertStudentTargetGroupsForStudentInput!) {
    upsertStudentTargetGroupsForStudent(input: $input) {
      studentTargetGroupNode {
        id
        isActive
        isCurrent
        targetGroup {
          id
        }
        user {
          id
        }
      }
      errors {
        __typename
      }
    }
  }
`;

export const getInferredDiagnosticSkills = graphql`
  query DiagnosticInferredSkillsQuery($studentId: ID!, $userId: ID!) {
    studentsDemonstratedSkillsReport(filter: { studentIds: [$userId] }) {
      demonstratedSkills
    }
    currentTargetGroupByStudentId(studentId: $studentId) {
      targetGroup {
        targets {
          targetSkills {
            isActive
            skill {
              id
            }
            targetSkillType {
              name
            }
          }
        }
      }
    }
  }
`;
